/**
 * @namespace ErrorHelper 
 */

export const ErrorHelper = {

    /** Detects returnq error message depends on error response object structure
     * @param {object } error response object
     * @returns {string} Error message
     */
    getMessage(error) {
        let message = "";
        if (error?.response?.data.errors?.length) {
            message = error.response.data.errors.map(e => e.message).join(', ');
        } else {
            message = error?.response?.data?.message;
        }
        return message;
    }
}
